import React from "react";
import "./TodosLoading.css";

function TodosLoading({ searchValue, setSearchValue }) {
  return <div className="todo-loading"></div>;
}

export { TodosLoading };
